valueProps